import { render, staticRenderFns } from "./MoneyTotal.vue?vue&type=template&id=225f2fc0&scoped=true&"
import script from "./MoneyTotal.vue?vue&type=script&lang=js&"
export * from "./MoneyTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225f2fc0",
  null
  
)

export default component.exports